import { render, staticRenderFns } from "./PrivacyLinks.vue?vue&type=template&id=263b2533&"
import script from "./PrivacyLinks.vue?vue&type=script&lang=js&"
export * from "./PrivacyLinks.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyLinks.vue?vue&type=style&index=0&id=263b2533&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports